import React from 'react';
import { Background, Content } from './styles';
import ClipLoader from 'react-spinners/ClipLoader';

function Modal() {
  return (
    <Background id='background'>
      <Content>
        <p>Processando pagamento...</p>
        <ClipLoader size={50} color='#000' />
      </Content>
    </Background>
  );
}

export default Modal;
